var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useConfig } from '@/store';
import { Stack } from '@chakra-ui/react';
export const BlockStyle = (_a) => {
    var _b, _c, _d;
    var { children, style_id, styles = {} } = _a, rest = __rest(_a, ["children", "style_id", "styles"]);
    const { getStyleConfig } = useConfig();
    const styleConfig = getStyleConfig(style_id) || styles;
    const on_primary = (_b = styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.on_primary) !== null && _b !== void 0 ? _b : '';
    const primary = (_d = (_c = styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.primary) !== null && _c !== void 0 ? _c : rest.bg) !== null && _d !== void 0 ? _d : '';
    const filterMap = {
        '#000000': 'brightness(0%)',
        '#FFFFFF': 'brightness(0%) invert(100%)'
    };
    return (_jsx(Stack, Object.assign({}, rest, { bg: primary, borderRadius: '8px', color: on_primary, css: { 'img:not(svg)': { filter: filterMap[on_primary] || '' } } }, { children: children })));
};
